export const FETCH_SUBMITTED_WARRANTY_LIST = "FETCH_SUBMITTED_WARRANTY_LIST";
export const FETCH_SUBMITTED_WARRANTY_LIST_SUCCESS = "FETCH_SUBMITTED_WARRANTY_LIST_SUCCESS";
export const UPDATE_ACTIVE_TAB = "UPDATE_ACTIVE_TAB";
export const RESET_SUBMITTED_WARRANTY_LIST = "RESET_SUBMITTED_WARRANTY_LIST";
export const FETCH_SUBMITTED_WARRANTY_LIST_FAILURE = "FETCH_SUBMITTED_WARRANTY_LIST_FAILURE";

export const FETCH_STATE_PROVINCE_LIST = "FETCH_STATE_PROVINCE_LIST";
export const FETCH_STATE_PROVINCE_LIST_SUCCESS = "FETCH_STATE_PROVINCE_LIST_SUCCESS";
export const FETCH_STATE_PROVINCE_LIST_FAILURE = "FETCH_STATE_PROVINCE_LIST_FAILURE";